import BaseHotspotSprite from "./BaseHotspotSprite";

/**
 * Type of hotspot for stickers - larger graphics without popups or hover effects
 */
export default class StickerHotspot extends BaseHotspotSprite {
  /**
   * Initialises a sticker hotspot based on a config object.
   *
   * @param player
   * @param config
   *
   * @example
   * {
   *   u: 0,
   *   v: 0.5,
   *   type: 'sticker',
   *   icon: {
   *     name: 'Icon name',
   *     uuid: '...',
   *     url?: 'https://...'
   *   },
   *   options: {
   *     tag: true,
   *     stickerSize: 'medium'
   *   },
   *   _options: {
   *     scale: 2
   *   }
   * }
   */
  constructor(player, config) {
    // Ensure sticker config has tag enabled
    // Create a deep copy to avoid modifying read-only objects
    const stickerConfig = {
      ...config,
      options: {
        ...config.options,
        tag: true,
      },
      _options: {
        ...(config._options || {}),
      },
    };
    
    // Calculate scale from stickerSize or customScale (prioritize these over _options.scale)
    let scale;
    
    // Check for custom scale first
    if (
      stickerConfig.options.customScale !== null &&
      stickerConfig.options.customScale !== undefined &&
      stickerConfig.options.customScale !== ""
    ) {
      const customScale = parseFloat(stickerConfig.options.customScale);
      scale = !isNaN(customScale) && customScale > 0 ? customScale : 2;
    } else if (stickerConfig.options.stickerSize) {
      // Use stickerSize if available
      const sizeMap = { small: 1, medium: 2, large: 3, xlarge: 4 };
      scale = sizeMap[stickerConfig.options.stickerSize] ?? 2;
    } else {
      // Fall back to _options.scale if set, otherwise default to 3
      scale = stickerConfig._options.scale ?? 2;
    }
    
    // Always set the scale in _options
    stickerConfig._options.scale = scale;

    super(player, stickerConfig);

    this.loadIcon(config.icon, "tag.png");

    this._config = stickerConfig;
  }
}

